import React, { useState } from 'react';
import * as styles from './PostModalViewTOC.module.scss';
import IconButton from '../../components/IconButton';
import SVGIcon from '../../components/SVGIcon';
import Tether from '../../components/Tether';
import type { DocumentType } from '../../graphql/generated';
import { gql } from '../../graphql/generated';
import tocIcon from '../../icons/non-prefilled/16x16/tableOfContentsNew.svg';
import ClickOutsideHandler from '../../utils/ClickOutsideHandler';
import ConnectedTableOfContents from '../actionButtons/ConnectedTableOfContents';
import TableOfContents from '../actionButtons/TableOfContents';

const POST_FRAGMENT = gql(`
  fragment PostModalViewTOC_post on Post {
    id
    ...TableOfContents_post
  }
`);

interface PostModalViewTOCProps {
  post: DocumentType<typeof POST_FRAGMENT>;
  portalContainer: HTMLElement | null;
}

const PostModalViewTOC = ({ post, portalContainer }: PostModalViewTOCProps) => {
  const [anchorElement, setAnchorElement] = useState<Element | null>(null);
  const [isOpen, setIsOpen] = useState(false);

  if (!portalContainer) return null;

  return (
    <ConnectedTableOfContents postId={post.id}>
      {(tocProps) => {
        const hasHeaders = tocProps.headers.length > 0;

        return (
          hasHeaders && (
            <ClickOutsideHandler onClickOutside={() => setIsOpen(false)}>
              <IconButton
                ref={setAnchorElement}
                aria-label="Table of Contents"
                applyNegativeMargin={false}
                onClick={() => setIsOpen(!isOpen)}
                className={styles.button}
              >
                <div className={styles.tocIcon}>
                  <SVGIcon>{tocIcon}</SVGIcon>
                </div>
              </IconButton>
              {isOpen && (
                <Tether
                  placement="bottom-start"
                  portalContainer={portalContainer}
                  offset={8}
                  positionedView={
                    <div className={styles.tocContainer}>
                      <h4 className={styles.title}>Table of Contents</h4>
                      <TableOfContents {...tocProps} post={post} />
                    </div>
                  }
                  anchorElement={anchorElement}
                />
              )}
            </ClickOutsideHandler>
          )
        );
      }}
    </ConnectedTableOfContents>
  );
};

export default PostModalViewTOC;
